<div class="flex flex-col bg-white comic-book">
  <!-- Sign Up Section -->
  <div
    class="title-header md:-top-16 flex flex-wrap min-h-screen background-blue relative border-4 border-black pb-10"
  >
    <div
      class="absolute bottom-0 bg-white right-20 z-50 w-full px-3.5 pb-2 h-auto"
    >
      <img
        src="/assets/images/artwork/vector-join.png"
        alt="Placeholder"
        class="absolute right-0 bottom-0 z-50 w-96 pointer-events-none"
      />

      <p
        class="font-bangers absolute right-44 w-40 z-50 text-black -top-48 text-center"
      >
        Join the team and become a hero!
      </p>
    </div>

    <span class="absolute w-1/4 right-0 h-full halftone top-right"></span>
    <span
      class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
    ></span>

    <div
      class="straighten w-full md:w-1/1 p-4 flex items-center justify-center"
    >
      <div class="p-8 md:p-8 w-full text-center relative -top-8">
        <div class="hero mt-6">
          <div class="hero-content flex-col lg:flex-row-reverse">
            <div class="text-center lg:text-left max-w-sm">
              <h2 class="text-container">
                <span
                  class="text text-flat font-bangers text-4xl md:text-6xl pr-2 bg-gradient-to-r from-blue-950 via-blue-700 to-blue-900"
                  >Join the Team!</span
                >
              </h2>

              <p class="mt-6 text-xl text-white">
                Ready to become a
                <span class="bg-red-600 font-extrabold p-1 text-2xl"
                  >Hero?</span
                >
                Create your account and join our mission to revolutionize
                education. Together, we'll make learning an adventure!
              </p>
            </div>
            <div class="max-w-sm">
              <div
                class="card flex-shrink-0 w-full shadow-2xl bg-base-100 border-t-4 border-t-red-600 dark:border-t-yellow-200"
              >
                <div class="card-body">
                  <form [formGroup]="signupForm" (ngSubmit)="signUpWithEmail()">
                    <div class="form-control">
                      <label class="label font-bangers" for="signup-email">
                        <span class="label-text">Email</span>
                      </label>
                      <input
                        type="email"
                        autocomplete="email"
                        id="signup-email"
                        class="input input-bordered text-black"
                        formControlName="email"
                      />
                      <p *ngIf="signupForm.controls.email.invalid && signupForm.controls.email.touched" class="mt-1 text-sm text-error" role="alert">Enter a valid email address.</p>
                    </div>
                    <div class="form-control">
                      <label class="label font-bangers" for="signup-password">
                        <span class="label-text">Password</span>
                      </label>
                      <input
                        type="password"
                        autocomplete="new-password"
                        id="signup-password"
                        class="input input-bordered text-black"
                        formControlName="password"
                      />
                      <p *ngIf="signupForm.controls.password.invalid && signupForm.controls.password.touched" class="mt-1 text-sm text-error" role="alert">Use at least 6 characters.</p>
                    </div>
                    <div class="form-control">
                      <label class="label font-bangers" for="signup-confirm-password">
                        <span class="label-text">Confirm Password</span>
                      </label>
                      <input
                        type="password"
                        autocomplete="new-password"
                        id="signup-confirm-password"
                        class="input input-bordered text-black"
                        formControlName="confirmPassword"
                      />
                      <p *ngIf="signupForm.controls.confirmPassword.invalid && signupForm.controls.confirmPassword.touched" class="mt-1 text-sm text-error" role="alert">Confirm your password.</p>
                    </div>

                    <div class="form-control mt-6">
                      <button
                        class="mt-3 btn btn-fast btn-primary font-bold py-2 px-4 ease-in-out duration-150 focus:outline-none focus:shadow-outline"
                        type="submit"
                        [disabled]="isSubmitting"
                      >
                        {{ isSubmitting ? 'Creating Account...' : 'Sign Up' }}
                      </button>
                    </div>
                  </form>

                  <button
                    (click)="signUpWithGoogle()"
                    class="mt-3 btn btn-fast btn-primary font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                    type="button"
                    [disabled]="isSubmitting"
                  >
                    Sign Up With Google
                  </button>
                </div>
              </div>

              <p class="text-accent p-3 text-center font-oswald">
                Already have an account?
                <a
                  class="font-extrabold font-oswald hover:text-primary"
                  routerLink="/login"
                  >Sign In</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
